"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppUpdateChannel = exports.getAppVersion = exports.getVersionKey = exports.getChannelKey = exports.getUrlKey = void 0;
const getUrlKey = (bindingCode) => `url_player_${bindingCode}`;
exports.getUrlKey = getUrlKey;
const getChannelKey = (bindingCode) => `update_channel_${bindingCode}`;
exports.getChannelKey = getChannelKey;
const getVersionKey = (bindingCode) => `player_version_${bindingCode}`;
exports.getVersionKey = getVersionKey;
const getAppVersion = (bindingCode) => localStorage.getItem((0, exports.getVersionKey)(bindingCode));
exports.getAppVersion = getAppVersion;
const getAppUpdateChannel = (bindingCode) => localStorage.getItem((0, exports.getChannelKey)(bindingCode));
exports.getAppUpdateChannel = getAppUpdateChannel;
//# sourceMappingURL=utils.js.map